(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/page-load.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/page-load.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const services = svs.components.chat.chatData.services;
const CHAT_PAGE_LOAD_INIT = 'CHAT/CHAT_PAGE_LOAD_INIT';
const CHAT_PAGE_LOAD_SUCCESS = 'CHAT/CHAT_PAGE_LOAD_SUCCESS';
const CHAT_PAGE_LOAD_FAILURE = 'CHAT/CHAT_PAGE_LOAD_FAILURE';
const CHAT_PAGE_LOAD_CLOSED = 'CHAT/CHAT_PAGE_LOAD_CLOSED';
const constants = svs.components.chat.chatData.constants;
const fetchMessagesByRoomId = function (roomId) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$reset = _ref.reset,
    reset = _ref$reset === void 0 ? false : _ref$reset,
    _ref$fetchRoom = _ref.fetchRoom,
    fetchRoom = _ref$fetchRoom === void 0 ? true : _ref$fetchRoom;
  return (dispatch, getState) => {
    const chatState = getState().Chat;
    if ((chatState.rooms[roomId] || {}).loading) return;
    const finalCallback = (err, results) => {
      if (err) {
        dispatch({
          type: CHAT_PAGE_LOAD_FAILURE,
          error: 'Det gick inte att initiera chatten',
          roomId
        });
      } else {
        const _results = _slicedToArray(results, 2),
          result1 = _results[0],
          result2 = _results[1];
        dispatch(_objectSpread(_objectSpread({
          type: CHAT_PAGE_LOAD_SUCCESS,
          roomId
        }, result1), {}, {
          room: result2,
          reset
        }));
      }
    };
    dispatch({
      type: CHAT_PAGE_LOAD_INIT,
      roomId
    });
    const oldestMessageId = !reset ? (chatState.messages[roomId] || [{}])[0].id : undefined;
    async.waterfall([callback => {
      if (fetchRoom) {
        services.getChatRoom(roomId, callback);
      } else {
        callback(null, {
          name: '',
          status: 'Open'
        });
      }
    }, (response, callback) => {
      if (response.status === constants.ROOM_STATUS_CLOSED && response.isCurrentChatRoomMemberBlocked) {
        return finalCallback(undefined, [{}, response]);
      }
      services.fetchMessages(roomId, oldestMessageId, (err, data) => {
        if (err && err.status === 403) {
          return dispatch({
            type: CHAT_PAGE_LOAD_CLOSED,
            roomId
          });
        }
        callback(err, [data, response]);
      });
    }], finalCallback);
  };
};
setGlobal('svs.components.chat.chatData.actions', {
  CHAT_PAGE_LOAD_INIT,
  CHAT_PAGE_LOAD_SUCCESS,
  CHAT_PAGE_LOAD_FAILURE,
  CHAT_PAGE_LOAD_CLOSED,
  fetchMessagesByRoomId
});

 })(window);